export default {
    //设置session
    setStorage(data) {
        sessionStorage.setItem('xx_system', JSON.stringify(data));
    },
    //获取session
    getStorage(type) {
        if (sessionStorage.getItem('xx_system')) {
            if (type) {
                return JSON.parse(sessionStorage.getItem('xx_system'))[type]
            } else {
                return JSON.parse(sessionStorage.getItem('xx_system'))
            }
        }
    },
    //移除session
    removeStorage() {
        sessionStorage.removeItem('xx_system')
    }
}